import NotificationBadge, {
  NotificationBadgeOpts,
} from 'src/game/components/shared/NotificationBadge';
import { createEmitter } from 'src/lib/Emitter';
import { getFriendshipRequestsCount } from 'src/replicant/friends/friends.getters';

export default class FriendshipRequestsBadge extends NotificationBadge {
  constructor(opts: NotificationBadgeOpts) {
    super(opts);

    createEmitter(this, ({ user }) =>
      getFriendshipRequestsCount(user),
    ).addListener((requests) => {
      if (requests > 0) {
        this.setText(requests.toString());
      } else {
        this.hide();
      }
    });
  }
}
